module.exports = __webpack_public_path__ + "img/brand-icon8.a85f0129.jpg";